module.exports = __webpack_public_path__ + "v4assets/library-screenshot.a1ce1c2cf1979745437ebf317b08d127.png";